import { isEmpty } from 'lodash'
import { CountryCode } from '../../i18n/countryCodes'
import { IServices } from './loadTaxServices'

export default function updateTaxServices(api: GlobalFetch) {
  return async function(lang: CountryCode, services: IServices[]) {
    if (isEmpty(services)) {
      services = []
      services.push({
        default: '0',
        first_tax: null,
        hidden: true,
        id: '0',
        price: null,
        second_tax: null,
        obligatory: false,
        free: false,
        rooms: ['0'],
        deleted: '0',
        service_name: 'dummy',
      } as any)
    }

    const requestBody = {
      lang,
      services: Object.values(services).map(s => ({
        ...s,
        hidden: s.hidden ? '1' : '0',
        deleted: s.deleted ? '1' : '0',
        obligatory: s.obligatory ? '1' : '0',
        free: s.free ? '1' : '0',
        max_amount: s.max_amount ? s.max_amount_value : 0,
        rooms: s.all_rooms ? ['0'] : s.rooms,
        max_amount_value: undefined,
        all_rooms: undefined,
        id: s.id.includes('+A') ? undefined : s.id,
      })),
    }

    const buildUrl = `/api/v2/service/index`
    const response = await api.fetch(buildUrl, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })
    const responseBody: IData = await response.json()

    return responseBody.items
  }
}

export interface IData {
  messages: string[]
  items: IServices[]
}
